
angular.module('zc.zenclerkS')
  .controller('ZcsAgencyUsersController', ZcsAgencyUsersController);

ZcsAgencyUsersController.$inject = ['$scope', '$stateParams', 'AgencyUser', 'currentUser', 'users'];

function ZcsAgencyUsersController($scope, $stateParams, AgencyUser, currentUser, users) {
  const vm = this;
  vm.users = users;
  vm.state = {};
  vm.currentUser = currentUser;
  vm.newUser = { email: '', full_name: '' };

  vm.inviteUser = inviteUser;
  vm.removeUser = removeUser;

  function sortUsers() {
    vm.users = _.sortBy(vm.users, user => {
      if(vm.currentUser.id === user.id) { return -1 }
      return user.id;
    });
  }

  //# Invite user
  function inviteUser() {
    AgencyUser.create($stateParams.agencyName, vm.newUser)
      .then(user => {
        vm.users.push(user);
        sortUsers();
        vm.newUser = { email: '', full_name: '' };
      });
  }

  //# Remove user
  function removeUser(user) {
    AgencyUser.destroy($stateParams.agencyName, user.id)
      .then(function(deletedUser) {
        _.remove(vm.users, u => u.id === deletedUser.id);
      });
  }

  //# Control for duplicate users
  $scope.$watch('vm.newUser.email', email => {
    if(email && !!_.find(vm.users, {email})) {
      $scope.form.$invalid = true; // disable form submit
      vm.state.duplicateUser = true; // show warning message
    } else {
      vm.state.duplicateUser = false;
    }
  });

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/users/agency_users.controller.js